var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"form",staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_vm._t("default",null,{"get":_vm.get,"set":_vm.set,"form":_vm.form,"submit":_vm.submit})],2)}
var staticRenderFns = []

export { render, staticRenderFns }